/** Equivalent positive-pitch Euler angles for MapLibre, continuous through nadir. */
export function signedCameraOrientation(rotation: number, tilt: number, roll: number) {
  const opposite = tilt < 0 ? 180 : 0;
  return { bearing: rotation + opposite, pitch: Math.abs(tilt), roll: roll + opposite };
}
